import { DynamicComponentExitReason } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { type SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { circleWarningIcon } from '@treasury/presentation/assets/icons/icon-circle-warning';
import { dispatchDialogCloseEvent } from '@treasury/presentation/services/dialog';
import { css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IdentityDialogResultInternal } from '././identity-verification-dialog.types';
import { IvdBase } from './identity-verification-dialog.base';
import { createDialogStrategy } from './strategies';

import '@treasury/presentation/components/jha-wc/tm-progress';
import '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-icon';

@customElement('identity-verification-dialog')
export class IdentityVerificationDialog extends IvdBase {
    public static get styles() {
        return css`
            :host {
                min-width: 340px;
            }
            .caption {
                padding: 10px;
            }
            .caption p:first-of-type {
                margin-top: 0;
            }
            .caption p:last-of-type {
                margin-bottom: 0;
            }
            .error {
                font-size: 8pt;
                font-weight: bold;
                padding: 10px;
                border: 1px solid var(--jh-color-red-650, red);
                background-color: var(--jha-background-color, white);
                box-shadow: 0 0 10px 0 rgba(57, 57, 57, 0.5);
                border-radius: 5px;
                margin-bottom: 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            .input-wrapper {
                margin: 20px;
            }
            .alert-wrapper {
                padding: 0 8px;
            }
            input {
                width: 100%;
                height: 32px;
                line-height: 34px;
                padding: 0px 10px;
                font-size: 16px;
                box-sizing: border-box;
            }

            .success-message {
                padding: 10px;
                text-align: center;
            }
            .container {
                min-width: 340px;
            }
        `;
    }

    protected createDialogStrategy(challengeMethodType: SecurityMessage['challengeMethodTypeId']) {
        return createDialogStrategy(this, challengeMethodType);
    }

    protected close(
        reason: DynamicComponentExitReason,
        dialogResult: IdentityDialogResultInternal
    ) {
        dispatchDialogCloseEvent(this, {
            reason,
            data: dialogResult,
        });
    }

    protected renderError(errorMessage?: string) {
        if (!errorMessage) {
            return nothing;
        }

        return html`<div class="alert-wrapper">
            <div class="error" role="alert">
                <tm-icon
                    .icon=${circleWarningIcon}
                    color=${'var(--jh-color-red-650, red)'}
                ></tm-icon>
                <span>${errorMessage}</span>
            </div>
            <div name="actions">
                <tm-button @click=${this.cancel}>Close</tm-button>
            </div>
        </div>`;
    }

    protected renderProgress() {
        if (!this.verifying) {
            return nothing;
        }

        return html`<tm-jh-progress card></tm-jh-progress>`;
    }
}
